export type DateSelectionOptions = 'month' | 'date';
export const SELECTED_DATE_TYPE_KEY = 'selectedDateType';
